const stylesheet = `

.react-jinke-music-player-main svg:active, .react-jinke-music-player-main svg:hover {
    color: #458588
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle, .react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-track {
    background-color: #ebdbb2
}

.react-jinke-music-player-main ::-webkit-scrollbar-thumb {
    background-color: #458588;
}

.react-jinke-music-player-main .music-player-panel .panel-content .rc-slider-handle:active {
    box-shadow: 0 0 2px #458588
}

.react-jinke-music-player-main .audio-item.playing svg {
    color: #458588
}

.react-jinke-music-player-main .audio-item.playing .player-singer {
    color: #458588 !important
}

.react-jinke-music-player-main .lyric-btn {
    color: #ebdbb2 !important
}

.react-jinke-music-player-main .lyric-btn-active svg {
    color: #458588 !important
}

.music-player-lyric {
    color: #458588 !important
}

.audio-lists-panel-content .audio-item.playing, .audio-lists-panel-content .audio-item.playing svg {
    color: #458588
}
.audio-lists-panel-content .audio-item:active .group:not([class=".player-delete"]) svg, .audio-lists-panel-content .audio-item:hover .group:not([class=".player-delete"]) svg {
    color: #458588
}

.progress-bar-content .audio-title a {
    color: #ebdbb2
}

.MuiCheckbox-colorSecondary.Mui-checked {
    color: #458588 !important
}
.react-jinke-music-player-main .music-player-panel svg {
    color: #ebdbb2;
    fill: #ebdbb2;
}
.react-jinke-music-player-main .music-player-panel button {
    color: #ebdbb2;
}
`

export default stylesheet
